// React
import React from 'react';

export default function Title(props) {
    return (
        <div className="title">{ props.children }</div>
    )
};
